export const handleChangeHelper = (event, productName, arrayIndex, formik) => {
  const { setFieldValue, setFieldTouched, setFieldError, values } = formik;

  const name = event.target.name;
  const value = event.target.value;
  // setFieldValue(name, event.target.value);
};

export const handleOnBlurHelper = () => {
  // Add your logic for onBlur if needed
};
